import keys from '../../oauth2.keys.json'
import * as Msal from "msal";

const msalInstance = new Msal.UserAgentApplication({
    auth: {
        clientId: process.env.VUE_APP_MS_CLIENT_ID
    },  
    cache: {  
        cacheLocation: "localStorage"          
    }
});
const validBusiness=process.env.VUE_APP_VALID_BUSINESS.split(' ');
const loginRequest = {
    scopes: ["user.read", "mail.send"] // optional Array<string>
}

const con = {    
    async created() {
        return {
            db: await this.getDb()
        }
    },
    async addKeys(db, key) {
        await this.addKeyToDb(db, key)
        return await this.getKeyFromDb(db);
    },
    async deleteKey(db, id) {
        return await this.deleteKeyFromDb(db, id)
              
    },
    
    async addKeyToDb(db, key) {
        return new Promise((resolve) => {
            let trans = db.transaction(['keys'],'readwrite');
            trans.oncomplete = () => {
                resolve();
            };
            let store = trans.objectStore('keys');
            store.add(key);
        });
    },
    async deleteKeyFromDb(db, id) {
        return new Promise((resolve) => {
            let req = db.transaction(['keys'],'readwrite').objectStore('keys').delete(id);
            req.onsuccess = function(){
                resolve(true);
            };
            req.onerror = ()=> {
                console.error(`Error to empty Object Store: ${id}`)
            }
        });
    },
    async getKeyFromDb(db) {
        return new Promise((resolve) => {
            let trans = db.transaction(['keys'],'readonly');
            trans.oncomplete = () => {
                resolve(keys[0]);
            };
            let store = trans.objectStore('keys');
            let keys = [];

            store.openCursor().onsuccess = e => {
                let cursor = e.target.result;
                if (cursor) {
                    keys.push(cursor.value)
                    cursor.continue();
                }
            };

        });
    },
    async getDb() {
        return new Promise((resolve, reject) => {
            let request = window.indexedDB.open('dbcdb', 3);
            request.onerror = e => {
                console.log('Error opening db', e);
                reject('Error');
            };

            request.onsuccess = e => {
                resolve(e.target.result);
            };

            request.onupgradeneeded = e => {
                console.log('onupgradeneeded');
                let db = e.target.result;
                let objectStore = db.createObjectStore("keys", { keyPath: "id_token" });
                console.log(objectStore)
            };
        });
    },
    async auth(url ="", data={}){
        const response = await fetch(url, {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(data).toString()
        })
        if(response.ok){
            return response.json()
        }
    },
    async checkToken(key){
        const url ="https://www.googleapis.com/oauth2/v1/tokeninfo"
        const qs = new URLSearchParams({
            "access_token": key.access_token
        });
        const response = await fetch(`${url}?${qs}`, {
            method: 'GET'
        })
        if(response.ok){
             return new Promise((resolve)=>{
                response.json().then((data)=>{
                    const email = data.email.substr(data.email.indexOf("@")+1)
                    const rpta = {
                        "valid":false,
                        "status":"bad"
                    }
                    if(validBusiness.indexOf(email) > -1){
                        rpta.valid = true;
                        rpta.status = "ok";
                        resolve(rpta)
                    }else{
                        resolve(rpta)
                    }
                });
            });
        }else{
            return con.auth(keys.web.token_uri, {
                "refresh_token":key.refresh_token,
                "client_id":keys.web.client_id,
                "client_secret": keys.web.client_secret,
                "grant_type": "refresh_token"
            }).then(async (data)=>{
                const db = await con.created()
                const old_key = await this.getKeyFromDb(db.db)
                await this.deleteKey(db.db, old_key.id_token)
                const new_key = await con.addKeys(db.db, data)
                return await this.checkToken(new_key)
            },(error)=>{
                console.log(error)
                return false
            })
        }
    },
    async logout(){
        const db = await con.created()
        let key = await this.getKeyFromDb(db.db)
        if(key === undefined){
            msalInstance.logout()
        }else{
            return await this.deleteKey(db.db, key.id_token);
        }
        return false;
    },
    async MSAcquireTokenSilent(){
        return msalInstance.acquireTokenSilent(loginRequest).then(response => {
            if(response){
                return true;
            }else{
                return false;
            }
        }).catch(error => {
            if(error.name !== 'ClientAuthError'){
                console.log(error);   
            }
        });
    },
    async signInWithMicrosoft(){
        msalInstance.loginRedirect(loginRequest)
    }
}

export default con